module.exports = __webpack_public_path__ + "img/P150T_weapon_160.8e3ba309.png";